<template>
  <div v-if="!loading">
    <v-card class="mt-8 mx-8 pa-4">
      <v-card-title>تنظیمات کلاس {{ onlineClass.title }}</v-card-title>
    </v-card>
  </div>
</template>

<script>
export default {
  name: "OnlineClassManageSetting",
  data() {
    return {
      loading: true,
      onlineClass: []
    }
  },
  mounted() {
    this.getOnlineClass()
  },
  methods: {
    getOnlineClass() {
      let url = '/class/crud/get/' + this.$route.params.id
      window.axios.get(url).then((res) => {
        this.onlineClass = res.data.data
        this.loading = false
      }).catch((err) => {
        this.openSnackbar(err.response.data.message, '#F1416C')
      })
    },
  }
}
</script>

<style scoped>

</style>